const FAQ_PLAY = [
  {
    title: 'Quais são as formas de pagamento? É seguro?',
    content: 'Aceitamos pagamento por Pix, cartão de crédito, PayPal e Boleto.'
  },
  {
    title: 'O que é o plano Play',
    content: (
      <>
        O Foguete Play é para você que quer apenas treinar com o conteúdo
        gravado e atualizado mensalmente.
      </>
    )
  },
  {
    title: 'Após assinar, terei acesso por quanto tempo? Existe fidelidade?',
    content: (
      <>
        A Academia Online Foguete é um produto em modelo de assinatura, sempre
        com renovação automática pela plataforma Hotmart no dia do vencimento do
        seu plano (dia em que foi feita a assinatura). Você pode assinar o plano
        trimestral, semestral ou anual. <br />
        <br />
        Para continuar acessando treinos ao vivo e gravados, é necessário manter
        o pagamento da sua assinatura sempre em dia.
      </>
    )
  },
  {
    title: 'Como funciona o cancelamento até o 7º dia?',
    content: (
      <>
        <p style={{ marginBottom: 15 }}>
          De acordo com a legislação, você pode realizar o cancelamento da
          assinatura até o 7o dia a partir da data da compra. Neste caso, você
          terá o reembolso relativo ao valor da compra e o prazo dependerá do
          método de pagamento conforme as referencias abaixo:
        </p>
        <p>
          <strong>Cartão de Crédito ou Débito</strong>
          <br />
          Prazo: Fatura atual ou próxima, dependendo se a compra foi feita no
          débito ou crédito.
          <br />
          Reembolso: Recebido no cartão cadastrado na compra.
        </p>

        <p>
          <strong>
            PayPal, Google Pay, Apple Pay, Carteira do App Hotmart
          </strong>
          <br />
          Prazo: Fatura atual ou próxima, de acordo com o tipo de cartão (débito
          ou crédito) vinculado.
          <br />
          Reembolso: Recebido nas contas vinculadas às carteiras digitais.
        </p>

        <p>
          <strong>PIX</strong>
          <br />
          Prazo: Até 7 dias úteis.
          <br />
          Reembolso: Efetuado na conta de origem do PIX.
        </p>

        <p>
          <strong>Boleto Bancário</strong>
          <br />
          Prazo: Até 7 dias úteis, contados a partir do preenchimento do
          formulário.
          <br />
          Reembolso: Depositado na conta bancária informada no formulário.
        </p>

        <p>
          <strong>Saldo Hotmart</strong>
          <br />
          Prazo: Até 5 dias úteis.
          <br />
          Reembolso: Valor creditado na conta Hotmart.
        </p>

        <p>
          <strong>Parcelex</strong>
          <br />
          Prazo: 8 dias úteis.
          <br />
          Reembolso: Parcelex entrará em contato para realizar o reembolso.
        </p>
      </>
    )
  },
  {
    title: 'Os treinos são apenas para casa?',
    content:
      'Não! A plataforma conta com séries de treinos tanto para casa quanto para Academia (musculação).'
  },
  {
    title: 'A Academia Foguete funciona pelo celular?',
    content: (
      <>
        Sim! Você poderá acessar os treinos através de qualquer dispositivo:
        celular, computador ou tablet. Basta fazer login na plataforma através
        do próprio navegador e todo o conteúdo aparecerá de forma amigável na
        sua tela.
        <br /> <br />
        Tudo que você precisa é uma conexão estável de Internet.
      </>
    )
  },
  {
    title: 'Serve para todos os níveis?',
    content: (
      <>
        A Academia Foguete é pensada para atender todo mundo! É só escolher o
        tipo de treino de acordo com seu nível e que mais te agrada e suar a
        camisa 🙂
      </>
    )
  },
  {
    title: 'Os treinos são só para mulheres ou homens também podem fazer?',
    content: (
      <>
        As séries também podem ser feitas por homens, não há qualquer restrição,
        o que muda é o seu objetivo e sua expectativa de resultado. Todos os
        vídeos de introdução das séries explicam como distribuir os exercícios
        de acordo com o seu objetivo.
        <br />
        No método de treinos do Ricardo Lapa cerca de 90% dos exercícios são
        multiarticulares (trabalham várias partes do corpo ao mesmo tempo),
        sempre com foco em intensidade, para quem deseja um corpo fit,
        equilibrado e saudável.
      </>
    )
  },
  {
    title: 'Os treinos são para emagrecer ou crescer?',
    content: (
      <>
        Os treinos do Ricardo Lapa são multiarticulares e independem do objetivo
        da aluna ou aluno. O que varia é a intensidade para cada objetivo, seja
        emagrecer ou ganhar massa muscular (hipertrofia).
        <br />
        Nos vídeos de introdução de cada uma das três séries o próprio Lapa
        explica como distribuir os exercícios de acordo com o seu objetivo.
        <br />
        Veja os resultados das nossas alunas e alunos na seção de Depoimentos
        aqui do site e também no feed do Instagram @lapateam. Você perceberá
        mudanças corporais para diferentes objetivos.
      </>
    )
  },
  {
    title: 'Como funciona a divisão dos treinos?',
    content: (
      <>
        O módulo em nossa plataforma chamado “Como organizar meu treino”, vai te
        ajudar a definir seu nível. Se é iniciante, intermediário ou avançado.
        <br />
        Basta seguir as orientações 😉
      </>
    )
  },
  {
    title: 'É obrigatório o uso de Equipamento/Peso?',
    content: (
      <>
        Não precisa obrigatoriamente ter peso ou acessório. Várias aulas são
        apenas com o peso corporal.
      </>
    )
  },
  {
    title: 'Os treinos são atualizados?',
    content: (
      <>Os treinos gravados são completos e atualizados todo início de mês!</>
    )
  },
  {
    title: 'O que são os Guias Nutricionais disponíveis na plataforma?',
    content: (
      <>
        São guias nutricionais para diferentes objetivos: emagrecimento e
        hipertrofia com opções de guias vegetarianos, veganos, para celíacos e
        intolerantes à lactose.
        <br />
        Esses cardápios são direcionados para que se tenha uma ideia de como
        montar o dia a dia e quais combinações de alimentos fazer para manter o
        equilíbrio.{' '}
      </>
    )
  },
  {
    title: 'Preciso deixar a câmera ligada no ao vivo?',
    content: <>Não precisa! Pode treinar com a câmera desligada.</>
  },
  {
    title: 'Eu consigo espelhar os treinos na TV?',
    content: (
      <>
        Sim, temos um vídeo explicativo aqui no{' '}
        <a href="https://www.instagram.com/reel/CyL0rMYuCm8/" target="_blank">
          nosso Instagram
        </a>
      </>
    )
  }
]

const FAQ_LIVE = [
  {
    title: 'Quais são as formas de pagamento? É seguro?',
    content: 'Aceitamos pagamento por Pix, cartão de crédito, PayPal e Boleto.'
  },
  {
    title: 'O que é o Plano Play+Ao Vivo?',
    content: (
      <>
        O Foguete Play+Ao Vivo é a experiência completa da Academia Online
        Foguete. Você vai ter acesso a todos os treinos online e ao vivo no
        Zoom. E, também, a todos os conteúdos gravados de treino.
      </>
    )
  },
  {
    title: 'Após assinar, terei acesso por quanto tempo? Existe fidelidade?',
    content: (
      <>
        A Academia Online Foguete é um produto em modelo de assinatura, sempre
        com renovação automática pela plataforma Hotmart no dia do vencimento do
        seu plano (dia em que foi feita a assinatura). Você pode assinar o plano
        trimestral, semestral ou anual. <br />
        <br />
        Para continuar acessando treinos ao vivo e gravados, é necessário manter
        o pagamento da sua assinatura sempre em dia.
      </>
    )
  },
  {
    title: 'Como funciona o cancelamento até o 7º dia?',
    content: (
      <>
        <p style={{ marginBottom: 15 }}>
          De acordo com a legislação, você pode realizar o cancelamento da
          assinatura até o 7o dia a partir da data da compra. Neste caso, você
          terá o reembolso relativo ao valor da compra e o prazo dependerá do
          método de pagamento conforme as referencias abaixo:
        </p>
        <p>
          <strong>Cartão de Crédito ou Débito</strong>
          <br />
          Prazo: Fatura atual ou próxima, dependendo se a compra foi feita no
          débito ou crédito.
          <br />
          Reembolso: Recebido no cartão cadastrado na compra.
        </p>

        <p>
          <strong>
            PayPal, Google Pay, Apple Pay, Carteira do App Hotmart
          </strong>
          <br />
          Prazo: Fatura atual ou próxima, de acordo com o tipo de cartão (débito
          ou crédito) vinculado.
          <br />
          Reembolso: Recebido nas contas vinculadas às carteiras digitais.
        </p>

        <p>
          <strong>PIX</strong>
          <br />
          Prazo: Até 7 dias úteis.
          <br />
          Reembolso: Efetuado na conta de origem do PIX.
        </p>

        <p>
          <strong>Boleto Bancário</strong>
          <br />
          Prazo: Até 7 dias úteis, contados a partir do preenchimento do
          formulário.
          <br />
          Reembolso: Depositado na conta bancária informada no formulário.
        </p>

        <p>
          <strong>Saldo Hotmart</strong>
          <br />
          Prazo: Até 5 dias úteis.
          <br />
          Reembolso: Valor creditado na conta Hotmart.
        </p>

        <p>
          <strong>Parcelex</strong>
          <br />
          Prazo: 8 dias úteis.
          <br />
          Reembolso: Parcelex entrará em contato para realizar o reembolso.
        </p>
      </>
    )
  },
  {
    title: 'Os treinos são apenas para casa?',
    content:
      'Não! A plataforma conta com séries de treinos tanto para casa quanto para Academia (musculação).'
  },
  {
    title: 'A Academia Foguete funciona pelo celular?',
    content: (
      <>
        Sim! Você poderá acessar os treinos através de qualquer dispositivo:
        celular, computador ou tablet. Basta fazer login na plataforma através
        do próprio navegador e todo o conteúdo aparecerá de forma amigável na
        sua tela.
        <br /> <br />
        Tudo que você precisa é uma conexão estável de Internet.
      </>
    )
  },
  {
    title: 'Como funcionam os treinos ao vivo? As aulas ficarão gravadas?',
    content: (
      <>
        Os treinos ao vivo são comandados pelo personal Ricardo Lapa e todo o
        time da Academia Online Foguete.
        <br />
        Através da ferramenta Zoom e são sempre coletivos, ou seja, todos se
        veem na tela. Assim, o próprio Lapa corrige os seus movimentos e torna
        aula única e divertida!
        <br />
        Os links dos treinos são sempre atualizados dentro da plataforma do
        Treino Online Foguete, de acordo com a agenda de horários. São mais de
        300 horários disponíveis por por mês para você treinar. Atendemos todos
        os níveis de intensidade e diferentes tipos de aula, como: Treino,
        Dança, Luta, Yoga e muito mais.
        <br />
        No entanto, as aulas não ficarão gravadas, pois já disponibilizamos
        treinos gravados mensais para você fazer tanto em casa quanto na
        academia.
      </>
    )
  },
  {
    title: 'Serve para todos os níveis?',
    content: (
      <>
        A Academia Foguete é pensada para atender todo mundo! É só escolher o
        tipo de treino de acordo com seu nível e que mais te agrada e suar a
        camisa 🙂
      </>
    )
  },
  {
    title: 'Os treinos são só para mulheres ou homens também podem fazer?',
    content: (
      <>
        As séries também podem ser feitas por homens, não há qualquer restrição,
        o que muda é o seu objetivo e sua expectativa de resultado. Todos os
        vídeos de introdução das séries explicam como distribuir os exercícios
        de acordo com o seu objetivo.
        <br />
        No método de treinos do Ricardo Lapa cerca de 90% dos exercícios são
        multiarticulares (trabalham várias partes do corpo ao mesmo tempo),
        sempre com foco em intensidade, para quem deseja um corpo fit,
        equilibrado e saudável.
      </>
    )
  },
  {
    title: 'Os treinos são para emagrecer ou crescer?',
    content: (
      <>
        Os treinos do Ricardo Lapa são multiarticulares e independem do objetivo
        da aluna ou aluno. O que varia é a intensidade para cada objetivo, seja
        emagrecer ou ganhar massa muscular (hipertrofia).
        <br />
        Nos vídeos de introdução de cada uma das três séries o próprio Lapa
        explica como distribuir os exercícios de acordo com o seu objetivo.
        <br />
        Veja os resultados das nossas alunas e alunos na seção de Depoimentos
        aqui do site e também no feed do Instagram @lapateam. Você perceberá
        mudanças corporais para diferentes objetivos.
      </>
    )
  },
  {
    title: 'Como funciona a divisão dos treinos?',
    content: (
      <>
        O módulo em nossa plataforma chamado “Como organizar meu treino”, vai te
        ajudar a definir seu nível. Se é iniciante, intermediário ou avançado.
        <br />
        Basta seguir as orientações 😉
      </>
    )
  },
  {
    title: 'É obrigatório o uso de Equipamento/Peso?',
    content: (
      <>
        Não precisa obrigatoriamente ter peso ou acessório. Várias aulas são
        apenas com o peso corporal.
      </>
    )
  },
  {
    title: 'Os treinos são atualizados?',
    content: (
      <>Os treinos gravados são completos e atualizados todo início de mês!</>
    )
  },
  {
    title: 'O que são os Guias Nutricionais disponíveis na plataforma?',
    content: (
      <>
        São guias nutricionais para diferentes objetivos: emagrecimento e
        hipertrofia com opções de guias vegetarianos, veganos, para celíacos e
        intolerantes à lactose.
        <br />
        Esses cardápios são direcionados para que se tenha uma ideia de como
        montar o dia a dia e quais combinações de alimentos fazer para manter o
        equilíbrio.{' '}
      </>
    )
  },
  {
    title: 'Preciso deixar a câmera ligada no ao vivo?',
    content: <>Não precisa! Pode treinar com a câmera desligada.</>
  },
  {
    title: 'Eu consigo espelhar os treinos na TV?',
    content: (
      <>
        Sim, temos um vídeo explicativo aqui no{' '}
        <a href="https://www.instagram.com/reel/CyL0rMYuCm8/" target="_blank">
          nosso Instagram
        </a>
      </>
    )
  }
]

const FAQ_DEFAULT = [
  {
    title: 'Quais são as formas de pagamento? É seguro?',
    content: 'Aceitamos pagamento por Pix, cartão de crédito, PayPal e Boleto.'
  },
  {
    title: 'Qual a diferença entre os planos: Play e Play+Ao Vivo?',
    content: (
      <>
        O Foguete Play é para você que quer apenas treinar com o conteúdo
        gravado e atualizado mensalmente. <br />
        <br />O Foguete Play+Ao Vivo é a experiência completa da Academia Online
        Foguete. Você vai ter acesso a todos os treinos online e ao vivo no
        Zoom. E, também, a todos os conteúdos gravados de treino.
      </>
    )
  },
  {
    title: 'Após assinar, terei acesso por quanto tempo? Existe fidelidade?',
    content: (
      <>
        A Academia Online Foguete é um produto em modelo de assinatura, sempre
        com renovação automática pela plataforma Hotmart no dia do vencimento do
        seu plano (dia em que foi feita a assinatura). Você pode assinar o plano
        trimestral, semestral ou anual. <br />
        <br />
        Para continuar acessando treinos ao vivo e gravados, é necessário manter
        o pagamento da sua assinatura sempre em dia.
      </>
    )
  },
  {
    title: 'Como funciona o cancelamento até o 7º dia?',
    content: (
      <>
        <p style={{ marginBottom: 15 }}>
          De acordo com a legislação, você pode realizar o cancelamento da
          assinatura até o 7o dia a partir da data da compra. Neste caso, você
          terá o reembolso relativo ao valor da compra e o prazo dependerá do
          método de pagamento conforme as referencias abaixo:
        </p>
        <p>
          <strong>Cartão de Crédito ou Débito</strong>
          <br />
          Prazo: Fatura atual ou próxima, dependendo se a compra foi feita no
          débito ou crédito.
          <br />
          Reembolso: Recebido no cartão cadastrado na compra.
        </p>

        <p>
          <strong>
            PayPal, Google Pay, Apple Pay, Carteira do App Hotmart
          </strong>
          <br />
          Prazo: Fatura atual ou próxima, de acordo com o tipo de cartão (débito
          ou crédito) vinculado.
          <br />
          Reembolso: Recebido nas contas vinculadas às carteiras digitais.
        </p>

        <p>
          <strong>PIX</strong>
          <br />
          Prazo: Até 7 dias úteis.
          <br />
          Reembolso: Efetuado na conta de origem do PIX.
        </p>

        <p>
          <strong>Boleto Bancário</strong>
          <br />
          Prazo: Até 7 dias úteis, contados a partir do preenchimento do
          formulário.
          <br />
          Reembolso: Depositado na conta bancária informada no formulário.
        </p>

        <p>
          <strong>Saldo Hotmart</strong>
          <br />
          Prazo: Até 5 dias úteis.
          <br />
          Reembolso: Valor creditado na conta Hotmart.
        </p>

        <p>
          <strong>Parcelex</strong>
          <br />
          Prazo: 8 dias úteis.
          <br />
          Reembolso: Parcelex entrará em contato para realizar o reembolso.
        </p>
      </>
    )
  },
  {
    title: 'Os treinos são apenas para casa?',
    content:
      'Não! A plataforma conta com séries de treinos tanto para casa quanto para Academia (musculação).'
  },
  {
    title: 'A Academia Foguete funciona pelo celular?',
    content: (
      <>
        Sim! Você poderá acessar os treinos através de qualquer dispositivo:
        celular, computador ou tablet. Basta fazer login na plataforma através
        do próprio navegador e todo o conteúdo aparecerá de forma amigável na
        sua tela.
        <br /> <br />
        Tudo que você precisa é uma conexão estável de Internet.
      </>
    )
  },
  {
    title: 'Como funcionam os treinos ao vivo? As aulas ficarão gravadas?',
    content: (
      <>
        Os treinos ao vivo são comandados pelo personal Ricardo Lapa e todo o
        time da Academia Online Foguete.
        <br />
        Através da ferramenta Zoom e são sempre coletivos, ou seja, todos se
        veem na tela. Assim, o próprio Lapa corrige os seus movimentos e torna
        aula única e divertida!
        <br />
        Os links dos treinos são sempre atualizados dentro da plataforma do
        Treino Online Foguete, de acordo com a agenda de horários. São mais de
        300 horários disponíveis por por mês para você treinar. Atendemos todos
        os níveis de intensidade e diferentes tipos de aula, como: Treino,
        Dança, Luta, Yoga e muito mais.
        <br />
        No entanto, as aulas não ficarão gravadas, pois já disponibilizamos
        treinos gravados mensais para você fazer tanto em casa quanto na
        academia.
      </>
    )
  },
  {
    title: 'Serve para todos os níveis?',
    content: (
      <>
        A Academia Foguete é pensada para atender todo mundo! É só escolher o
        tipo de treino de acordo com seu nível e que mais te agrada e suar a
        camisa 🙂
      </>
    )
  },
  {
    title: 'Os treinos são só para mulheres ou homens também podem fazer?',
    content: (
      <>
        As séries também podem ser feitas por homens, não há qualquer restrição,
        o que muda é o seu objetivo e sua expectativa de resultado. Todos os
        vídeos de introdução das séries explicam como distribuir os exercícios
        de acordo com o seu objetivo.
        <br />
        No método de treinos do Ricardo Lapa cerca de 90% dos exercícios são
        multiarticulares (trabalham várias partes do corpo ao mesmo tempo),
        sempre com foco em intensidade, para quem deseja um corpo fit,
        equilibrado e saudável.
      </>
    )
  },
  {
    title: 'Os treinos são para emagrecer ou crescer?',
    content: (
      <>
        Os treinos do Ricardo Lapa são multiarticulares e independem do objetivo
        da aluna ou aluno. O que varia é a intensidade para cada objetivo, seja
        emagrecer ou ganhar massa muscular (hipertrofia).
        <br />
        Nos vídeos de introdução de cada uma das três séries o próprio Lapa
        explica como distribuir os exercícios de acordo com o seu objetivo.
        <br />
        Veja os resultados das nossas alunas e alunos na seção de Depoimentos
        aqui do site e também no feed do Instagram @lapateam. Você perceberá
        mudanças corporais para diferentes objetivos.
      </>
    )
  },
  {
    title: 'Como funciona a divisão dos treinos?',
    content: (
      <>
        O módulo em nossa plataforma chamado “Como organizar meu treino”, vai te
        ajudar a definir seu nível. Se é iniciante, intermediário ou avançado.
        <br />
        Basta seguir as orientações 😉
      </>
    )
  },
  {
    title: 'É obrigatório o uso de Equipamento/Peso?',
    content: (
      <>
        Não precisa obrigatoriamente ter peso ou acessório. Várias aulas são
        apenas com o peso corporal.
      </>
    )
  },
  {
    title: 'Os treinos são atualizados?',
    content: (
      <>Os treinos gravados são completos e atualizados todo início de mês!</>
    )
  },
  {
    title: 'O que são os Guias Nutricionais disponíveis na plataforma?',
    content: (
      <>
        São guias nutricionais para diferentes objetivos: emagrecimento e
        hipertrofia com opções de guias vegetarianos, veganos, para celíacos e
        intolerantes à lactose.
        <br />
        Esses cardápios são direcionados para que se tenha uma ideia de como
        montar o dia a dia e quais combinações de alimentos fazer para manter o
        equilíbrio.{' '}
      </>
    )
  },
  {
    title: 'Preciso deixar a câmera ligada no ao vivo?',
    content: <>Não precisa! Pode treinar com a câmera desligada.</>
  },
  {
    title: 'Eu consigo espelhar os treinos na TV?',
    content: (
      <>
        Sim, temos um vídeo explicativo aqui no{' '}
        <a href="https://www.instagram.com/reel/CyL0rMYuCm8/" target="_blank">
          nosso Instagram
        </a>
      </>
    )
  }
]

export const FAQ = {
  default: FAQ_DEFAULT,
  live: FAQ_LIVE,
  play: FAQ_PLAY
}
